import { useEffect, useMemo, useState, useRef } from 'react';
import { Line } from 'react-konva';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { redoPanelState, undoPanelState } from 'store/slices/PanelSlice';
import { resizePoints } from '../utils';
import { useKonvaImageScale } from 'contexts/ToolDimensionsAndScaleContext';
import { DEV_STROKE_FACET_COLOR } from '../../../constants';
import Konva from 'konva';

export default function SimplifiedConcaveHullLines(){
	const [showLine, setShowLine] = useState(false);
	const { allRoofSegs, designType } = useSelector((state: RootState) => state.roofData.data);
	const { editModeEnabled, deletedRoofIndexes, enabledDevMode } 
	= useSelector((state: RootState) => state.toolNewPostions.data);
	const scale= useKonvaImageScale();
	const dispatch = useDispatch();
	const lineRefs = useRef<Array<{ id: string; ref: Konva.Line | null }>>([]);

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			const key = event.key.toLowerCase();
			if((event.ctrlKey || event.metaKey) && key === 'z' && !event.shiftKey) {
				dispatch(undoPanelState());
			} else if((event.ctrlKey || event.metaKey) && (key === 'y' || (key === 'z' && event.shiftKey))) {
				dispatch(redoPanelState());
			} else if ((event.key === 'l' || event.key === 'L')) {
				event.preventDefault();
				setShowLine(true);
			}
		};

		const handleKeyUp = (event: KeyboardEvent) => {
			setShowLine(false);
		};
		window.addEventListener('keydown', handleKeyDown);
		window.addEventListener('keyup', handleKeyUp);
		return () => {
			window.removeEventListener('keydown', handleKeyDown);
			window.removeEventListener('keyup', handleKeyUp);
		};
	}, [dispatch]);

	const transformedRoofSegments = useMemo(() => (
		allRoofSegs.map(segment => {
			const transformedPoints = resizePoints(segment?.simplifiedHullCoords?.flat() ?? [], scale);
			return {
				points: transformedPoints,
				id: segment.id,
				userMapped: segment.userMapped
			};
		})), [allRoofSegs, scale]);

	useEffect(() => {
		if (showLine) {
			lineRefs.current.forEach(({ ref }) => {
				if (ref && ref.getLayer()) {
					ref.moveToTop();
					ref.getLayer()?.batchDraw();
				}
			});
		}
	}, [showLine]);

	if(!showLine ) {
		return null;
	}

	return (
		<>
			{
				transformedRoofSegments.map(eachSeg => {
					if (deletedRoofIndexes.includes(eachSeg.id)) return null;
					return (<Line
						name='simplified-hull'
						key={eachSeg.id}
						ref={(node) => {
							const index = lineRefs.current.findIndex(item => item.id === eachSeg.id);
							if (index !== -1) {
								lineRefs.current[index].ref = node;
							} else {
								lineRefs.current.push({ id: eachSeg.id, ref: node });
							}
						}}
						stroke={(enabledDevMode && eachSeg.userMapped) ? DEV_STROKE_FACET_COLOR : (showLine ? 'red' : 'rgba(29,53,87,.50)')}
						strokeWidth={1.5}
						strokeScaleEnabled={false}
						points={eachSeg.points}
					/>);}
				)
			}
		</>
	);
}
